module.exports = __webpack_public_path__ + "img/NymbleUp - N.f65ce900.jpg";